module.exports = require("./lib/_stream_transform.js")



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/transform.js
// module id = 211
// module chunks = 0